import { useRef } from "react";
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import "./CardGrupoFamiliar.css";
import WarningIcon from "../../../assets/images/generico/WarningIcon";
import GrupoFamiliarIcon from "../../../assets/images/generico/GrupoFamiliarIcon";
import camelize from "../../../../global/utils/camelize";
import TildeOkAbonado from "../../../assets/images/generico/TildeOkAbonado";
import { showModal } from "../../../context/Actions/modal/modal";
import CardGrupoFamiliarPending from "./CardGrupoFamiliarPending/CardGrupoFamiliarPending";
import CardGrupoFamiliaPending2 from "./CardGrupoFamiliaPending2/CardGrupoFamiliaPending2";
import defaultPerfil from "../../../assets/images/generico/defaultUserImage.png";
import { IonSpinner } from "@ionic/react";
import { GlobalContext } from "../../../../global/context/Provider";
import { wsGetTiposParentesco } from "_+_Portal/context/Actions/grupoFamiliar/grupoFamiliar";
import { showToaster } from "global/context/action/toaster/toaster";

const CardGrupoFamiliar = ({
  item,
  derecho_editarPerfil,
  derecho_verResultados,
  derecho_manejoTurnos,
  derecho_editarPerfil_otros,
  derecho_verResultados_otros,
  derecho_manejoTurnos_otros,
}) => {
  const { modalDispatch, listaFamiliaresState, grupoFamiliarDispatch } =
    useContext(PortalContext);

  // Cambio de contexto
  const { authState, toasterDispatch } = useContext(GlobalContext);

  const trackButton = useRef();
  // abriendo modal para desvincular al familiar
  // GF = Grupo Familiar
  const handleClickModalGF = () => {
    showModal(
      "Perfil/ModalGrupoFamiliar/ModalGrupoFamiliar",
      {
        nombre: camelize(item.idPaciente2Desc),
        idpaciente1: authState.auth.data.paciente.codigo,
        idpaciente2: item.idPaciente2,
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  // abriendo modal para editar
  const handleModalEditar = () => {
    wsGetTiposParentesco((isCorrect, data) => {
      if (isCorrect) {
        showModal(
          "Perfil/ModalAddFamiliar/ModalAddFamiliar",
          {
            nombre: camelize(item.idPaciente2Desc),
            idpaciente1: authState.auth.data.paciente.codigo,
            idpaciente2: item.idPaciente2,
            editar: true,
            familiarCompleto: item,
          },
          [],
          "centro",
          true
        )(modalDispatch);
      } else {
        showToaster(
          {
            tipo: "danger",
            texto: "No se han podido cargar los tipos de parentesco.",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    })(grupoFamiliarDispatch);
  };

  return (
    <div>
      {item.idParentescoProceso === 1 &&
      item.idPaciente1 === authState.auth.data.paciente.codigo ? (
        <CardGrupoFamiliaPending2
          idpaciente2_desc={item.idPaciente2Desc}
          idpaciente2={item.idPaciente2}
          idpaciente1={item.idPaciente1}
          parentesco={item.parentesco}
          idFamiliar={item.id}
        />
      ) : item.idParentescoProceso === 1 ? (
        <CardGrupoFamiliarPending
          idpaciente2_desc={item.idPaciente1Desc}
          idpaciente2={item.idPaciente2}
          idpaciente1={item.idPaciente1}
          id={item.id}
          derecho_editarPerfil={derecho_editarPerfil_otros}
          derecho_verResultados={derecho_verResultados_otros}
          derecho_manejoTurnos={derecho_manejoTurnos_otros}
        />
      ) : (
        <div className="ptur-grupoFamiliar-card" ref={trackButton}>
          <div className="ptur-grupoFamiliar-titulo bgcG-latex30">
            <div className="ptur-grupoFamiliar-iconParentesco">
              <div className="ptur-grupoFamiliar-margin5">
                <GrupoFamiliarIcon />
                <span>{item.parentesco}</span>
              </div>
              <div className="ptur-grupoFamiliar-botonContainer">
                <button
                  className="ptur-grupoFamiliar-botonDesvincular rb16m c-white"
                  onClick={handleModalEditar}
                >
                  Editar
                </button>
                <button
                  className="ptur-grupoFamiliar-botonDesvincular rb16m c-white"
                  onClick={handleClickModalGF}
                >
                  Desvincular
                </button>
              </div>
            </div>
          </div>
          <div className="ptur-grupoFamiliar-card-cuerpo">
            <div className="ptur-grupoFamiliar-perfilImg-box">
              {listaFamiliaresState.listaFamiliares.loading ? (
                <IonSpinner name="lines" />
              ) : (
                <img
                  className={`ptur-grupoFamiliar-perfilImg-img`}
                  src={
                    item.imagenPerfil
                      ? `data:image/jpeg;base64,${item.imagenPerfil}`
                      : defaultPerfil
                  }
                  alt="Perfil"
                />
              )}
            </div>
            <div className="rb18b">{camelize(item.idPaciente2Desc)}</div>
            <hr className="ptur-grupoFamiliar-separador" />
            <div className="ptur-grupoFamiliar-derechos-icon">
              <div className="ptur-grupoFamiliar-iconWarning">
                <WarningIcon />
              </div>
              <div className="ptur-grupoFamiliar-InfoDerechos rb14m">
                Usted tiene los siguientes derechos en el Portal sobre este
                familiar
              </div>
            </div>
            <div className="ptur-grupoFamiliar-derechos">
              <div className="ptur-grupoFamiliar-derechosTilde">
                {derecho_editarPerfil === true ? (
                  <div className="ptur-grupoFamiliar-tilde c-broccoli rb14m">
                    <TildeOkAbonado />
                    Editar Perfil
                  </div>
                ) : (
                  ""
                )}
                {derecho_manejoTurnos === true ? (
                  <div className="ptur-grupoFamiliar-tilde c-broccoli rb14m">
                    <TildeOkAbonado />
                    Manejo Turnos
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="ptur-grupoFamiliar-derechosTilde">
                {derecho_verResultados === true ? (
                  <div className="ptur-grupoFamiliar-tilde c-broccoli rb14m">
                    <TildeOkAbonado />
                    Ver Resultados
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CardGrupoFamiliar;
